import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useHistory } from "../../../utils/router";
import { getLink, objectToFormData, toast } from "../../../utils/helpers";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import Form from "./Form";
import { apiRequest } from "../../../hooks/apiRequest";

const Edit = () => {
    const { id } = useParams();

    const history = useHistory();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [insumo, setInsumo] = useState({});
    const [esValido, setEsValido] = useState(false);

    const cancelar = () => {
        const from = location.state?.from || getLink("/salud/inventario");
        
        history.push(from);
    }

    const editarInsumo = async () => {
        if (!esValido) return toast('Favor llenar todos los campos requeridos', 'error');

        setSaving(true);

        setErrors({});
        
        const data = objectToFormData({...insumo, "_method": "put"});

        const response = await postRequest(apiUrl(`salud/insumos/${id}`), data);
                
        if (response.success) {
            history.push(getLink("/salud/inventario"));
        }

        if (response.code === 422) {
            setErrors(response.data.message);
        }

        setSaving(false);
    };

    const getInsumo = async () => {
        const response = await apiRequest({}, `salud/insumos/${id}`, 'get');

        if (response.success) {
            setInsumo(response.data);
        } else {
            toast('Error obteniendo el insumo', 'error');
            cancelar();
        }

        setLoading(false);
    };

    useEffect(() => {
        getInsumo();
    }, []);

    if (loading) return <Loader></Loader>;

    return <>
        <div className="row">
            <div className="col-md-12 order-2 order-md-1">
                <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                    <h1>Editar Insumo</h1>

                    <Form insumo={insumo} setInsumo={setInsumo} setEsValido={setEsValido} errors={errors} saving={saving} />
                </div>
            </div>
        </div>

        <div className="row pt-4">
            <button
                type="button"
                className="btn btn-plain ml-auto mr-2"
                onClick={cancelar}
            >
                Descartar
            </button>

            <button
                type="button"
                className="btn btn-primary ml-2 mr-3"
                onClick={() => editarInsumo()}
            >
                Guardar
            </button>
        </div>
    </>;
};

export default Edit;